import { EVehicleAssetType } from '@/context/borrower';

/**
 * Determines if vehicle details should be shown based on asset type and loan usage
 * @param assetType - The type of asset being financed
 * @param isPersonalUse - Whether the loan is for personal use
 * @returns boolean indicating if vehicle details should be shown
 */
export function shouldShowVehicleDetails(
    assetType: EVehicleAssetType | undefined,
    isPersonalUse: boolean
): boolean {
    // Don't show vehicle details for personal use loans
    if (isPersonalUse) {
        return false;
    }

    // Don't show if asset type is undefined
    if (!assetType) {
        return false;
    }

    // List of asset types that are considered vehicles (car, bike, van)
    const vehicleAssetTypes = [
        // Cars
        EVehicleAssetType.PASSENGER_VEHICLE,
        EVehicleAssetType.PASSENGER_VEHICLE_LUX,
        EVehicleAssetType.MOTOR_VEHICLES,
        EVehicleAssetType.MOTOR_VEHICLES_SEC,
        EVehicleAssetType.GREY_IMPORT,
        EVehicleAssetType.GREY_IMPORTS,

        // Bikes
        EVehicleAssetType.MOTORCYCLE,
        EVehicleAssetType.MOTORBIKES_REG,
        EVehicleAssetType.MOTORBIKES_UNREG,

        // Vans (including commercial vehicles and trucks)
        EVehicleAssetType.COMM_VEH_LT_4_5,
        EVehicleAssetType.TRUCK_LT_4_5,
        EVehicleAssetType.TRUCK_GT_4_5,
        EVehicleAssetType.TRUCKS_LT_4_5,
        EVehicleAssetType.TRUCKS_RIGID_4_5,
        EVehicleAssetType.PRIME_MOVERS,
    ];

    // Only show vehicle details for car, bike, van asset types
    return vehicleAssetTypes.includes(assetType);
}
